import { createSelector } from 'reselect';
import _ from 'lodash';

import { selectorTipusIncidencies } from './selector_estacio_formulari_estructura';
import { selectorTotsUsuaris } from './selector_usuari';
import {
    selectorGrupsMetadades,
    selectorMetadades,
    selectorCampsMetadades,
    selectorOpcionsTipusEstacio,
    selectorIdsVariablesMomentsObligatoris
} from './selector_estacio_formulari_estructura';

// SELECTORS SECCIONS
const obtenirDadesOriginals = (dadesSeccio) => {
    if (!dadesSeccio) return null;

    return dadesSeccio.originals;
};

const obtenirDadesEditades = (dadesSeccio) => {
    return dadesSeccio.editades;
};

const dadesBasiques = state => state.estacio.formulari.dades.dadesBasiques;

const selectorDadesBasiquesOriginals = createSelector(
    dadesBasiques,
    obtenirDadesOriginals
);

export const selectorDadesBasiquesEditades = createSelector(
    dadesBasiques,
    obtenirDadesEditades
);

const afegirCodiTipusEstacioADadesBasiques = (dadesBasiques, opcionsTipusEstacio) => {

    const { idTipusEstacio } = dadesBasiques;
    const tipusEstacio = opcionsTipusEstacio.find(opcioTipusEstacio => opcioTipusEstacio.id === idTipusEstacio);

    if (!tipusEstacio) {
        return dadesBasiques;
    }

    return { ...dadesBasiques, codiTipusEstacio: tipusEstacio.codi };

};

export const selectorDadesBasiquesOriginalsAmbCodiDeTipusEstacio = createSelector(
    selectorDadesBasiquesOriginals,
    selectorOpcionsTipusEstacio,
    afegirCodiTipusEstacioADadesBasiques
);

const fotos = state => state.estacio.formulari.dades.fotos;

export const selectorFotosOriginals = createSelector(
    fotos,
    obtenirDadesOriginals
);

const obtenirFotosEliminades = (fotos) => {
    if (!fotos) return null;

    return fotos.eliminades;
};

const obtenirFotosCreades = (fotos) => {
    if (!fotos) return null;

    return fotos.creades;
};

export const selectorFotosEliminades = createSelector(
    fotos,
    obtenirFotosEliminades
);

export const selectorFotosCreades = createSelector(
    fotos,
    obtenirFotosCreades
);

const localitzacio = state => state.estacio.formulari.dades.localitzacio;

export const selectorLocalitzacioOriginals = createSelector(
    localitzacio,
    obtenirDadesOriginals
);

export const selectorLocalitzacioEditades = createSelector(
    localitzacio,
    obtenirDadesEditades
);

export const selectorLocalitzacioEditadesCoordenades = (state) => {
    const localitzacioEditades = selectorLocalitzacioEditades(state);
    return {
        latitud: localitzacioEditades.latitud,
        longitud: localitzacioEditades.longitud
    };
};

export const selectorLocalitzacioEditadesAltitud = state => selectorLocalitzacioEditades(state).altitud;

export const selectorLocalitzacioEditadesErrorsCoordenades = (state) => {
    return {
        latitud: selectorMostrarErrors(state) && selectorHiHaAlgunErrorASeccioLocalitzacioLatitud(state),
        longitud: selectorMostrarErrors(state) && selectorHiHaAlgunErrorASeccioLocalitzacioLongitud(state)
    };
};

const variablesMoments = state => state.estacio.formulari.dades.variablesMoments;

export const selectorVariablesMomentsOriginals = createSelector(
    variablesMoments,
    obtenirDadesOriginals
);

export const selectorVariablesMomentsEditades = createSelector(
    variablesMoments,
    obtenirDadesEditades
);

const metadades = state => state.estacio.formulari.dades.metadades;

export const selectorMetadadesOriginals = createSelector(
    metadades,
    obtenirDadesOriginals
);

export const selectorMetadadesEditades = createSelector(
    metadades,
    obtenirDadesEditades
);

const ajuntarEstructuraIValorsMetadades = (grupsMetadades, metadades, campsMetadades, metadadesEstacio) => {

    const idsGrups = Object.keys(grupsMetadades);
    const idsGrupsOrdenats = idsGrups.sort((idGrupA, idGrupB) => grupsMetadades[idGrupA].ordre - grupsMetadades[idGrupB].ordre);

    return idsGrupsOrdenats.map(idGrup => {
        const grup = {
            id: parseInt(idGrup, 10),
            nom: grupsMetadades[idGrup].nom,
            metadades: []
        };

        grupsMetadades[idGrup].idMetadades.forEach(idMetadada => {
            if (metadadesEstacio[idMetadada]) {
                const metadada = {
                    id: idMetadada,
                    nom: metadades[idMetadada].nom,
                    camps: metadades[idMetadada].idCampsMetadades.map(idCamp => {
                        return { ...campsMetadades[idCamp], id: idCamp, valor: metadadesEstacio[idMetadada][idCamp] };
                    })
                };

                grup.metadades.push(metadada);

            }
        });

        return grup;

    });

};

export const selectorMetadadesOriginalsAmbEstructura = createSelector(
    selectorGrupsMetadades,
    selectorMetadades,
    selectorCampsMetadades,
    selectorMetadadesOriginals,
    ajuntarEstructuraIValorsMetadades
);

export const selectorMetadadesEditadesAmbEstructura = createSelector(
    selectorGrupsMetadades,
    selectorMetadades,
    selectorCampsMetadades,
    selectorMetadadesEditades,
    ajuntarEstructuraIValorsMetadades
);

const restarMetadadesActivesAMetadadesGrup = (grupsMetadades, metadades, metadadesEstacio) => {
    let objecteMetadadesAMostrarPerGrup = {};

    Object.keys(grupsMetadades).forEach(idGrup => {
        const grup = grupsMetadades[idGrup];
        grup.idMetadades.forEach(idMetadada => {
            const metadada = metadades[idMetadada];
            if (!metadadesEstacio[idMetadada]) {
                objecteMetadadesAMostrarPerGrup[idGrup] = objecteMetadadesAMostrarPerGrup[idGrup] || [];
                objecteMetadadesAMostrarPerGrup[idGrup].push({id: idMetadada, valor: metadada.nom});
            }
        });
    });

    return objecteMetadadesAMostrarPerGrup;
};

export const selectorMetadadesDisponiblesPerGrup = createSelector(
    selectorGrupsMetadades,
    selectorMetadades,
    selectorMetadadesEditades,
    restarMetadadesActivesAMetadadesGrup
);

const historicObservadors = state => state.estacio.formulari.dades.historicObservadors;

export const selectorHistoricObservadorsOriginals = createSelector(
    historicObservadors,
    obtenirDadesOriginals
);

export const selectorHistoricObservadorsEditades = createSelector(
    historicObservadors,
    obtenirDadesEditades
);

const afegirNomCognomsICodiDeUsuariAHistoricObservadors = (historicObservadors, usuaris) => {

    return historicObservadors.map((registre) => {
        const usuari = usuaris[registre.idUsuari];

        if (usuari) {
            registre = {
                ...registre,
                nom: usuari.nom,
                cognom1: usuari.cognom1,
                cognom2: usuari.cognom2,
                codi: usuari.codi
            };
        }

        return registre;
    });

};

export const selectorHistoricObservadorsOriginalsAmbNomCognomsICodi = createSelector(
    selectorHistoricObservadorsOriginals,
    selectorTotsUsuaris,
    afegirNomCognomsICodiDeUsuariAHistoricObservadors
);

export const selectorHistoricObservadorsEditadesAmbNomCognomsICodi = createSelector(
    selectorHistoricObservadorsEditades,
    selectorTotsUsuaris,
    afegirNomCognomsICodiDeUsuariAHistoricObservadors

);

const incidencies = state => state.estacio.formulari.dades.incidencies;

export const selectorIncidenciesOriginals = createSelector(
    incidencies,
    obtenirDadesOriginals
);

export const selectorIncidenciesEditades = createSelector(
    incidencies,
    obtenirDadesEditades
);

// DETECCIO MODIFICACIONS SECCIONS

const shaModificatSeccio = (originals, editades) => {
    return !(_.isEqual(originals, editades));
};

export const selectorShaModificatSeccioDadesBasiques = createSelector(
    selectorDadesBasiquesOriginals,
    selectorDadesBasiquesEditades,
    shaModificatSeccio
);

const shanEliminatFotos = (eliminades) => {
    const nombreFotosEliminades = eliminades.length;
    return nombreFotosEliminades > 0;
};

export const selectorShanEliminatFotos = createSelector(
    selectorFotosEliminades,
    shanEliminatFotos
);

export const selectorShaModificatSeccioLocalitzacio = createSelector(
    selectorLocalitzacioOriginals,
    selectorLocalitzacioEditades,
    shaModificatSeccio
);

const shaModificatSeccioVariables = (originals, editades) => {
    return !(_.isEqual([...originals].sort(), [...editades].sort()));
};

export const selectorShaModificatSeccioVariables = createSelector(
    selectorVariablesMomentsOriginals,
    selectorVariablesMomentsEditades,
    shaModificatSeccioVariables
);

export const selectorShaModificatSeccioMetadades = createSelector(
    selectorMetadadesOriginals,
    selectorMetadadesEditades,
    shaModificatSeccio
);

const shaModificatSeccioTipusArrayPersonalitzat = (originals, editades, propietatOrdenacio, propietatAExcloure) => {
    const originalsMap = originals.map(objecteOriginals => _.omit(objecteOriginals, propietatAExcloure));
    const editadesMap = editades.map(objecteEditades => _.omit(objecteEditades, propietatAExcloure));

    return !_.isEqual(_.sortBy(originalsMap, propietatOrdenacio), _.sortBy(editadesMap, propietatOrdenacio));
};

const shaModificatSeccioHistoricObservadors = (originals, editades) => {
    const propietatAExcloure = 'idEstacioUsuari';
    const propietatOrdenacio = 'idUsuari';
    return shaModificatSeccioTipusArrayPersonalitzat(originals, editades, propietatOrdenacio, propietatAExcloure);
};

export const selectorShaModificatSeccioHistoricObservadors = createSelector(
    selectorHistoricObservadorsOriginals,
    selectorHistoricObservadorsEditades,
    shaModificatSeccioHistoricObservadors
);

const shaModificatSeccioIncidencies = (originals, editades) => {
    const propietatAExcloure = 'id';
    const propietatOrdenacio = 'idTipusIncidencia';
    return shaModificatSeccioTipusArrayPersonalitzat(originals, editades, propietatOrdenacio, propietatAExcloure);
};

export const selectorShaModificatSeccioIncidencies = createSelector(
    selectorIncidenciesOriginals,
    selectorIncidenciesEditades,
    shaModificatSeccioIncidencies
);

const afegirTipusIncidenciaAIncidencies = (incidencies, tipusIncidencies) => {
    return incidencies.map(registre => {
        const tipus = tipusIncidencies[registre.idTipusIncidencia];
        return { ...registre, tipus };
    });
};

export const selectorIncidenciesOriginalsAmbTipus = createSelector(
    selectorIncidenciesOriginals,
    selectorTipusIncidencies,
    afegirTipusIncidenciaAIncidencies
);

export const selectorIncidenciesEditadesAmbTipus = createSelector(
    selectorIncidenciesEditades,
    selectorTipusIncidencies,
    afegirTipusIncidenciaAIncidencies
);

const selectorHiHaAlgunErrorASeccioLocalitzacioLatitud = (state) => {
    const localitzacio = selectorLocalitzacioEditades(state);
    if (!localitzacio) return true;
    if (!localitzacio.latitud) return true;
    return false;
};

const selectorHiHaAlgunErrorASeccioLocalitzacioLongitud = (state) => {
    const localitzacio = selectorLocalitzacioEditades(state);
    if (!localitzacio) return true;
    if (!localitzacio.longitud) return true;
    return false;
};

export const selectorHiHaAlgunErrorASeccioLocalitzacio = (state) => {
    if (selectorHiHaAlgunErrorASeccioLocalitzacioLatitud(state)) return true;
    if (selectorHiHaAlgunErrorASeccioLocalitzacioLongitud(state)) return true;
    return false;
};

// VISUALITZACIÓ DE FOTOS AL COMPONENT
const fotosOriginalsMenysFotosEliminades = (originals, eliminades) => {
    return _.differenceWith(originals, eliminades, _.isEqual);
};

export const selectorFotosOriginalsMenysFotosEliminades = createSelector(
    selectorFotosOriginals,
    selectorFotosEliminades,
    fotosOriginalsMenysFotosEliminades
);

export const selectorPeticioInserirEnCurs = state => state.estacio.formulari.peticioEnviarFormulariEnCurs;

// DETECCIO ERRORS DADES OBLIGATÒRIES
const esDadaStringNoInformada = dada => (dada === undefined || dada === null || dada === '');
const esDadaStringSuperiorAlMaximDeCaracters = (dada, maximCaracters) => (dada) ? dada.length > maximCaracters : false;

const maximCaractersCodiEstacio = 5;

export const selectorMostrarErrors = state => state.estacio.formulari.mostrarErrors;

export const selectorCodiEstacioNoInformat = createSelector(
    selectorDadesBasiquesEditades,
    (dadesBasiquesEditades) => esDadaStringNoInformada(dadesBasiquesEditades.codi)
);

export const selectorNomEstacioNoInformat = createSelector(
    selectorDadesBasiquesEditades,
    (dadesBasiquesEditades) => esDadaStringNoInformada(dadesBasiquesEditades.nom)
);

export const selectorDataAltaDataBaixaNoCoherents = createSelector(
    selectorDadesBasiquesEditades,
    (dadesBasiquesEditades) => esDadaStringNoInformada(dadesBasiquesEditades.dataAlta) && !esDadaStringNoInformada(dadesBasiquesEditades.dataBaixa)
);

export const selectorCodiEstacioSuperaMaximCaracters = createSelector(
    selectorDadesBasiquesEditades,
    (dadesBasiquesEditades) => esDadaStringSuperiorAlMaximDeCaracters(dadesBasiquesEditades.codi, maximCaractersCodiEstacio)
);

export const selectorTipusEstacioNoInformat = createSelector(
    selectorDadesBasiquesEditades,
    (dadesBasiquesEditades) => esDadaStringNoInformada(dadesBasiquesEditades.idTipusEstacio)
);

export const selectorEstaSeccioVariablesDeshabilitada = createSelector(
    selectorDadesBasiquesEditades,
    (dadesBasiques) => !dadesBasiques.dataAlta || !!dadesBasiques.dataBaixa
);

const hiHaErrorSeccioVariables = (seccioDeshabilitada, idsVariablesMomentsSeleccionats, idsVariablesMomentsObligatoris) => {

    if (seccioDeshabilitada) {
        return false;
    }

    const idsVariablesMomentsObligatorisSeleccionats = _.intersection(idsVariablesMomentsSeleccionats, idsVariablesMomentsObligatoris);

    return idsVariablesMomentsObligatorisSeleccionats.length <= 0;

};

export const selectorHiHaErrorSeccioVariables = createSelector(
    selectorEstaSeccioVariablesDeshabilitada,
    selectorVariablesMomentsEditades,
    selectorIdsVariablesMomentsObligatoris,
    hiHaErrorSeccioVariables
);

const algunCampObligatoriConteErrors = (...args) => args.some(campConteErrors => campConteErrors === true);

export const selectorErrorEnDadesObligatories = createSelector(
    selectorCodiEstacioNoInformat,
    selectorNomEstacioNoInformat,
    selectorDataAltaDataBaixaNoCoherents,
    selectorCodiEstacioSuperaMaximCaracters,
    selectorTipusEstacioNoInformat,
    selectorHiHaAlgunErrorASeccioLocalitzacio,
    selectorHiHaErrorSeccioVariables,
    algunCampObligatoriConteErrors
);


// WEBPACK FOOTER //
// ./src/selectors/selector_estacio_formulari_dades.js